// extracted by mini-css-extract-plugin
export default {"checkboxLabel":"Checkbox_checkboxLabel__titJJ","checkboxInput":"Checkbox_checkboxInput__KiAFR","checkboxSpan":"Checkbox_checkboxSpan__FyFKm"};